import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { UiKitLinkCopy } from 'packages/libs/fo/ui/kit/link/copy/src';

import StarIcon from '@/fo/icons/base/icons/rating.svg';

import { styles } from './UiProductInfoTop.styles';

export interface UiProductInfoTopProps {
  rating: number;
  url: string;
  className?: string;
}

export function UiProductInfoTop({
  rating,
  url,
  className
}: UiProductInfoTopProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base({ className })}>
      <Link
        href="#review"
        className={slots.link()}
      >
        <StarIcon
          className={
            rating
              ? 'text-icon-star'
              : 'text-inactive group-hover:[&>path]:fill-icon-brand'
          }
        />
        {rating ? (
          <>
            {rating} / {t('Reviews')}
          </>
        ) : (
          t('review.empty.reviews')
        )}
      </Link>
      <UiKitLinkCopy
        link={url}
        needOrigin
      />
    </div>
  );
}
